import {SoftDeleteEntity} from './soft-delete-entity';
import {Card} from './card';
import {BankTransferLoad} from './bankTransferLoad';
import {AppIdentityUserLight} from './app-identity-user-light';
import {PaymentSource} from './payment-source';
import {BaseEntity} from "./base-entity";
import {Customer} from "./customer";

export class TrustPayTransaction extends SoftDeleteEntity {
  createDate: Date;
  statementDate: Date;
  updateDate: Date|null;
  processedDate: Date|null;
  isProcessed: boolean;
  amount: number;
  accountId: string;
  reference: string;
  description: string;
  counterAccount: string;
  counterAccountMasked: string;
  counterAccountName: string;
  paymentId: string;
  cardFound: Card|null;
  cardFoundId: number|null;
  willRefund: boolean;
  source: PaymentSource;
  status: number;
}

export enum WhiteListType {
  Personal = 0,
  Global = 1,
}

export enum BankTransferLoadTransactionType {
  WebService = 1,
  Csv,
}

export class BankTransferLoadTransaction {
  bankTransferLoadId: number;
  bankTransferLoad: BankTransferLoad|null;
  amountLoaded: number;
  transactionDate: Date;
  type: BankTransferLoadTransactionType;
  exportedUser: AppIdentityUserLight|null;
  lastGpsStatusDate: Date|null;
  lastGpsStatus: string|null;

}


export class CardToCardTransfer {
  destinationCardId: number;
  destinationCard: Card;
  sourceCardId: number;
  sourceCard: Card;

  transferDate: Date|null;

  amount: number;
  payerFee: number;
  payeeFee: number;

  txnId: string;
  description: string;

}

export class DeclineReason {
  code: string;
  text: string;
  customerTextDe: string;
  customerTextEn: string;
}

export class WhiteListedBankAccount extends BaseEntity{
  createdDate: Date;
  type: WhiteListType;
  customerId: number;
  customer: Customer|null;
  userId: string;
  senderAccountName: string;
  senderAccountNumber: string;
  user: AppIdentityUserLight|null;

}

export interface AccountNameInfoModel {
  firstNames: string[];
  lastNames: string[];
  confidence: number;
  accountType: RealEntityType;
}

export enum RealEntityType {
  Personal = 1,
  Business = 2,
  GovernmentalEntity = 3,
  Insurance = 4,
  JointAccount = 20,
  Unknown = 99,
}

export interface FirstNamesLastNamesModel {
  firstNames: string[];
  lastNames: string[];
}

export interface SelfLoadDeterminationModel {
  selfLoadScore: number;
  accountNameInfo: AccountNameInfoModel;
  firstNamesLastNames: FirstNamesLastNamesModel;
}
